import NewCreditCardView from "./view";
import { useNavigate } from "react-router-dom";
import useCreditCardForm from "../hooks/useCreditCardForm";
import { useSingleFlag } from "@/hooks/useFlags";
import Loading from "@/atomic/atoms/Loading";
import useCaptcha from "@/hooks/useCaptcha";
import { useCallback, useMemo, useState } from "react";

export default function NewCreditCard() {
  const navigate = useNavigate();
  const {
    isEnabled: isAutoPaymentEnabled,
    isLoading: isLoadingAutoPaymentFlag,
  } = useSingleFlag("PD_COBRANCA_DIRETA");
  const { isLoading: isLoadingCaptchaFlag } = useSingleFlag(
    "PD_CAPTCHA_MTCAPTCHA",
  );

  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(0);

  const captchaName = useMemo(
    () => `mtcaptcha-new-credit-card-${captchaKey}`,
    [captchaKey],
  );

  const setIsCaptchaVerifiedCallback = useCallback((value: boolean) => {
    setIsCaptchaVerified(value);
  }, []);

  useCaptcha({
    setIsVerified: setIsCaptchaVerifiedCallback,
    captchaName,
  });

  const incrementCaptchaKey = useCallback(() => {
    setCaptchaKey((prev) => prev + 1);
  }, []);

  const resetCaptcha = useCallback(() => {
    setIsCaptchaVerified(false);
    if ((window as any)?.mtcaptcha?.resetUI) {
      (window as any).mtcaptcha.resetUI(captchaName);
    }
    incrementCaptchaKey();
  }, [captchaName, incrementCaptchaKey]);

  const {
    toggleModal,
    isVisibleModal,
    isVisibleConfirmationModal,
    isVisibleDisableAutoPaymentModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errorChangeMethod,
    errors,
    success,
    handleConfirmAutoPayment,
    handleCancelAutoPayment,
    handleAutoPaymentChange,
    handleConfirmDisableAutoPaymentModal,
    handleCancelDisableAutoPaymentModal,
    watch,
    customer,
  } = useCreditCardForm({
    navigate,
    changeMethod: true,
    isAutoPaymentEnabled,
    captchaName,
    isCaptchaVerified,
    resetCaptcha,
  });

  const goBack = () => navigate(-1);

  return (
    <>
      {isLoadingAutoPaymentFlag && <Loading />}
      <NewCreditCardView
        isLoading={isLoading}
        goBack={goBack}
        isDisabled={isDisabled}
        success={success}
        isVisibleModal={isVisibleModal}
        toggleModal={toggleModal}
        isVisibleConfirmationModal={isVisibleConfirmationModal}
        isVisibleDisableAutoPaymentModal={isVisibleDisableAutoPaymentModal}
        handleConfirmAutoPayment={handleConfirmAutoPayment}
        handleCancelAutoPayment={handleCancelAutoPayment}
        handleAutoPaymentChange={handleAutoPaymentChange}
        handleConfirmDisableAutoPaymentModal={
          handleConfirmDisableAutoPaymentModal
        }
        handleCancelDisableAutoPaymentModal={
          handleCancelDisableAutoPaymentModal
        }
        register={register}
        handleSubmit={handleSubmit}
        errorChangeMethod={errorChangeMethod}
        errors={errors}
        watch={watch}
        isAutoPaymentEnabled={isAutoPaymentEnabled}
        isEditing={customer?.account?.paymentMode === "2"}
        initialAutoPaymentState={customer?.account?.idPaymentType === "1"}
        captchaName={captchaName}
        isCaptchaVerified={isCaptchaVerified}
        isLoadingCaptchaFlag={isLoadingCaptchaFlag}
      />
    </>
  );
}
